<div class="col-sm-12 offset-md-1 col-md-10 mt-3">
  <ng-container *ngIf="this.patientreg.other_data.tabViewData.selected_tab == 0">
    <div class="row toplogin">
      <div class="form-back h4 my-4">
        <a class="egd-theme" role="button" [routerLink]="['/', this.slug]">&#8592; Back</a>
      </div>
      <div class="center-ayush-logo" *ngIf="this.isAyushupchar">
        <a href="https://ayushupchar.com/">
          <img src="assets/images/aayush_upchar_logo.jpeg" class="ayush-navbar-logo" alt="egd-ayush-logo" />
        </a>
      </div>
      <div>
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL', '', '_self')">
          <img [src]="this.logo_url" class="egd-navbar-logo" alt="egd-logo" style="float: right" />
        </a>
      </div>
    </div>
    <!-- <div class="form-back h4 my-4">
        <a routerLink="/">&#8592; Back</a>
      </div>
      <div class="form-logo">
        <a
          href="javascript:void(0)"
          (click)="openLink('HOMPAGE_BASE_URL', '', '_self')"
        >
          <img src="assets/images/logo.png" alt="egd-logo" />
        </a>
      </div> -->

    <div class="form-heading-section mt-4">
      <h2>Register</h2>
      <p class="form-sub-heading">
        Just a step away from starting your consultation!
      </p>
      <p class="form-tagline"><small>Register</small></p>
    </div>

    <form #registerForm="ngForm" (ngSubmit)="userRegistrationSubmit()" accept-charset="UTF-8" id="register_form">
      <div class="form-div">
        <div class="form-group row pl-md-1 justify-content-center">
          <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="name">Name*</label>
          <div class="col-sm-12 col-md-5">
            <input type="text" class="form-control rounded-pill" id="firstname" name="firstname" aria-describedby="name"
              placeholder="First Name*" [(ngModel)]="this.patientreg.api_data.userPatient.first_name"
              #first_name="ngModel" [pKeyFilter]="name_input" [class.form-input-error]="
                first_name.invalid &&
                (first_name.dirty || first_name.touched) &&
                first_name.errors.required
              " [class.form-input-success]="
                !first_name.invalid &&
                (first_name.dirty || first_name.touched) &&
                !first_name.errors?.required
              " required />
            <div *ngIf="
                first_name.invalid && (first_name.dirty || first_name.touched)
              " class="col-sm-12">
              <div *ngIf="first_name.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                First name is required.
              </div>
              <div *ngIf="first_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2" role="alert">
                Invalid First name.
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-5">
            <input type="text" class="form-control rounded-pill" id="middlename" name="middlename"
              aria-describedby="middlename" placeholder="Middle Name"
              [(ngModel)]="this.patientreg.api_data.userPatient.middle_name" [pKeyFilter]="name_input" />
          </div>
        </div>
        <div class="form-group row justify-content-center">
          <div class="col-md-10 col-sm-12">
            <input type="text" class="form-control rounded-pill" id="lastname" name="lastname"
              aria-describedby="lastname" placeholder="Last Name*"
              [(ngModel)]="this.patientreg.api_data.userPatient.last_name" #last_name="ngModel"
              [pKeyFilter]="name_input" [class.form-input-error]="
                last_name.invalid &&
                (last_name.dirty || last_name.touched) &&
                last_name.errors.required
              " [class.form-input-success]="
                !last_name.invalid &&
                (last_name.dirty || last_name.touched) &&
                !last_name.errors?.required
              " required />
            <div *ngIf="
                last_name.invalid && (last_name.dirty || last_name.touched)
              " class="col-sm-12 px-0">
              <div *ngIf="last_name.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                Last name is required.
              </div>
              <div *ngIf="last_name.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2" role="alert">
                Invalid Last name.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row justify-content-center">
          <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="password">Create Password*</label>
          <div class="col-md-10 col-sm-12">
            <div class="input-group">
              <input id="password" name="password" [type]="
                  this.patientreg.other_data.password_input.isPassword
                    ? 'password'
                    : 'text'
                " class="form-control input-of-input-icon" aria-describedby="password" placeholder="********"
                [(ngModel)]="this.patientreg.api_data.userPatient.e_password" #password="ngModel" minlength="8"
                FieldValidator="password" [class.form-input-error]="
                  password.invalid &&
                  (password.dirty || password.touched) &&
                  password.errors.required
                " [class.form-input-success]="
                  !password.invalid &&
                  (password.dirty || password.touched) &&
                  !(password.errors?.required || password.errors?.minlength)
                " required />
              <div class="input-group-append">
                <span class="input-group-text icon-of-input-icon" [class.form-input-error]="
                    password.invalid &&
                    (password.dirty || password.touched) &&
                    password.errors.required
                  " [class.form-input-success]="
                    !password.invalid &&
                    (password.dirty || password.touched) &&
                    !(password.errors?.required || password.errors?.minlength)
                  ">
                  <i toggle="#password-field" role="button" class="text-dark fa fa-fw" [ngClass]="{
                      'fa-eye':
                        this.patientreg.other_data.password_input.isPassword,
                      'fa-eye-slash':
                        !this.patientreg.other_data.password_input.isPassword
                    }" (click)="
                      this.patientreg.other_data.password_input.toggleType()
                    "></i>
                </span>
              </div>
            </div>
            <div *ngIf="password.invalid && (password.dirty || password.touched)" class="col-sm-12">
              <div *ngIf="password.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                Password is required.
              </div>
              <div *ngIf="password.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2" role="alert">
                Password should contain minimum 8 characters, at least 1
                Uppercase, 1 Special Character and 1 number.
              </div>
              <div *ngIf="password.errors.minlength" class="col-sm-12 alert alert-danger m-2" role="alert">
                Minimum length should be of 8 characters.
              </div>
            </div>
            <div class="col-sm-12">
              <div *ngIf="
                  this.patientreg.other_data.password_input.tipsPasswordShowed
                " class="col-sm-12 alert alert-danger m-2" role="alert">
                Password should contain minimum 8 characters, at least 1
                Uppercase, 1 Special Character and 1 number.
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="form-group row">
                    <label class="col-sm-12" for="password">Confirm Password*</label>
                    <div class="col-sm-12">
                        <div class="input-group">
                            <input id="confirmPassword" name="confirmPassword"
                                [type]="this.patientreg.other_data.password_input.isPassword?'password':'text'"
                                class="form-control input-of-input-icon" aria-describedby="confirmPassword"
                                placeholder="********"
                                [(ngModel)]="this.patientreg.api_data.userPatient.confirmpassword"
                                #confirmPassword="ngModel" minlength="8" FieldValidator="password"
                                [class.form-input-error]="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && (confirmPassword.errors.required)"
                                [class.form-input-success]="(!confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && !(confirmPassword.errors?.required || confirmPassword.errors?.minlength)"
                                required>
                            <div class="input-group-append">
                                <span class="input-group-text icon-of-input-icon"
                                    [class.form-input-error]="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && (confirmPassword.errors.required)"
                                    [class.form-input-success]="(!confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) && !(confirmPassword.errors?.required || confirmPassword.errors?.minlength)">
                                    <i toggle="#password-field" role="button" class="text-dark fa fa-fw"
                                        [ngClass]="{'fa-eye': this.patientreg.other_data.password_input.isPassword,'fa-eye-slash': !this.patientreg.other_data.password_input.isPassword}"
                                        (click)="this.patientreg.other_data.password_input.toggleType()"></i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="(confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched))"
                            class="col-sm-12">
                            <div *ngIf="confirmPassword.errors.required" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Confirm Password is required.
                            </div>
                            <div *ngIf="confirmPassword.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Password should contain minimum 8 characters, at least 1 Uppercase, 1
                                Special Character and 1 number.
                            </div>
                            <div *ngIf="confirmPassword.errors.minlength" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Minimum length should be of 8 characters.
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div *ngIf="confirmPassword.value!=password.value" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Password and Confirm Password do not match.
                            </div>
                        </div>
                    </div>
                </div> -->
        <!-- comented for new registration process :-->
        <!---
                <div class="form-group row">
                    <label class="col-sm-12" for="email">Email*</label>
                    <div class="col-md-12 col-sm-12">
                        <input id="email" name="email" type="email" class="form-control rounded-pill"
                            aria-describedby="email" FieldValidator="email" placeholder="Enter your email"
                            [(ngModel)]="this.patientreg.api_data.userPatient.email" #email="ngModel"
                            [class.form-input-error]="(email.invalid && (email.dirty || email.touched)) && (email.errors?.FieldValidator )"
                            [class.form-input-success]="(!email.invalid && (email.dirty || email.touched)) && !(email.errors?.FieldValidator )" required>
                        <div *ngIf="(email.invalid && (email.dirty || email.touched))" class="col-sm-12">
                            <div *ngIf="email.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                                    Email is required.
                                </div>
                            <div *ngIf="email.errors.FieldValidator" class="col-sm-12 alert alert-danger m-2"
                                role="alert">
                                Invalid Email.
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="form-group row">
                    <label class="col-sm-12" for="gender">Gender*</label>
                    <div class="col-md-12 col-sm-12">
                        <select name="gender" class="custom-select custom-select mb-3" 
                            [(ngModel)]="this.patientreg.api_data.userPatient.gender" #gender="ngModel"
                            [class.form-input-error]="(gender.invalid && (gender.dirty || gender.touched)) && (gender.errors.required)"
                            [class.form-input-success]="(!gender.invalid && (gender.dirty || gender.touched)) && !(gender.errors?.required)"
                            required>
                            <option value="" disabled selected>Choose your Gender*</option>
                            <option *ngFor="let gender of gender_list"
                                value={{gender.value}}>
                                {{gender.label}}
                            </option>
                        </select>
                        <div *ngIf="(gender.invalid && (gender.dirty || gender.touched))" class="col-sm-12">
                            <div *ngIf="gender.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                                    Gender is required.
                            </div>
                        </div>
                    </div>
                </div>
            -->
        <div class="form-group row justify-content-center">
          <div class="col-sm-12 col-md-5">
            <div class="row">
              <label class="col-sm-12 font-weight-bold ml-md-3 pl-md-2" for="country">Country*</label>
              <div class="col-sm-12 ml-md-2">
                <select name="country" class="custom-select custom-select mb-3 notranslate" (change)="onChangeCountry()"
                  [(ngModel)]="this.patientreg.other_data.selected_country" #country="ngModel" [class.form-input-error]="
                    country.invalid &&
                    (country.dirty || country.touched) &&
                    country.errors.required
                  " [class.form-input-success]="
                    !country.invalid &&
                    (country.dirty || country.touched) &&
                    !country.errors?.required
                  " required>
                  <option value="" disabled selected>
                    Choose your country*
                  </option>
                  <option *ngFor="let country of this.patientreg.other_data.countries" value="{{ country.value }}">
                    {{ country.label }}
                  </option>
                </select>
              </div>
              <div *ngIf="country.invalid && (country.dirty || country.touched)" class="col-sm-12">
                <div *ngIf="country.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                  Country is required.
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-5">
            <div class="row">
              <label class="col-sm-12 font-weight-bold" for="primary_no">Primary Mobile Number*</label>
              <div class="col-sm-12 ml-md-2">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text prepend-of-append-prepend patient_reg_input_border"
                      [class.form-input-error]="
                        primary_no?.invalid &&
                        (primary_no?.dirty || primary_no?.touched) &&
                        (primary_no.errors?.required ||
                          primary_no.errors?.maxlength ||
                          primary_no.errors?.pattern)
                      " [class.form-input-success]="
                        !primary_no?.invalid &&
                        (primary_no?.dirty || primary_no?.touched) &&
                        !(
                          primary_no.errors?.required ||
                          primary_no.errors?.maxlength ||
                          primary_no.errors?.pattern
                        )
                      ">
                      {{
                      this.patientreg.other_data.selected_country_data
                      .phone_code
                      }}
                    </span>
                  </div>
                  <input id="primary_no" name="primary_no" type="text" class="form-control input-of-append-prepend"
                    aria-describedby="primary_no" placeholder="Primary Contact No.*"
                    [(ngModel)]="this.patientreg.other_data.primary_contact_no" [pattern]="phoneNumber" maxlength="20"
                    #primary_no="ngModel" [class.form-input-error]="
                      primary_no?.invalid &&
                      (primary_no?.dirty || primary_no?.touched) &&
                      (primary_no.errors?.required ||
                        primary_no.errors?.maxlength ||
                        primary_no.errors?.pattern)
                    " [class.form-input-success]="
                      !primary_no?.invalid &&
                      (primary_no?.dirty || primary_no?.touched) &&
                      !(
                        primary_no.errors?.required ||
                        primary_no.errors?.maxlength ||
                        primary_no.errors?.pattern
                      )
                    " required />
                </div>
              </div>

              <div *ngIf="
                  primary_no?.invalid &&
                  (primary_no?.dirty || primary_no?.touched)
                " class="col-sm-12 pl-2">
                <div *ngIf="primary_no.errors?.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                  Primary Phone No. is required.
                </div>
                <!-- <div *ngIf="primary_no.errors?.maxlength" class="col-sm-12 alert alert-danger m-2"
                                    role="alert">
                                    Phone number should be of 10 digits.
                                </div> -->
                <div *ngIf="primary_no.errors?.pattern" class="col-sm-12 alert alert-danger m-2" role="alert">
                  Only Numbers are allowed.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Comented for new registration process -->

        <div class="form-group row justify-content-center">
          <label class="col-sm-12 font-weight-bold ml-md-5 pl-md-5" for="sources">How did you come to know about
            us?*</label>
          <div class="col-md-10 col-sm-12">
            <select name="sources" class="custom-select custom-select mb-3"
              [(ngModel)]="this.patientreg.api_data.userPatient.user_source_id" #source="ngModel"
              [class.form-input-error]="
                source.invalid &&
                (source.dirty || source.touched) &&
                source.errors.required
              " [class.form-input-success]="
                !source.invalid &&
                (source.dirty || source.touched) &&
                !source.errors?.required
              " required>
              <option value="null" disabled selected>
                Choose your source*
              </option>
              <option *ngFor="let source of this.patientreg.other_data.sources" [value]="source.value"
                [disabled]="this.isAyushupchar && source.value !== patientreg.api_data.userPatient.user_source_id">
                {{ source.label }}
              </option>
            </select>
            <div *ngIf="source.invalid && (source.dirty || source.touched)" class="col-sm-12">
              <div *ngIf="source.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                Sources is required.
              </div>
            </div>
          </div>

          <div *ngIf="
              getEmptyNumberChecker(
                this.patientreg.api_data.userPatient.user_source_id
              ) && this.patientreg.api_data.userPatient.user_source_id == 12
            ">
            <div class="col-sm-12">
              <input id="otherSource" name="otherSource" type="text" class="form-control rounded-pill ml-0 ml-lg-3"
                placeholder="Enter the Other Source*" [(ngModel)]="this.patientreg.api_data.userPatient.other_source"
                #otherSource="ngModel" [class.form-input-error]="
                  otherSource.invalid &&
                  (otherSource.dirty || otherSource.touched) &&
                  otherSource.errors?.required
                " [class.form-input-success]="
                  !otherSource.invalid &&
                  (otherSource.dirty || otherSource.touched) &&
                  !otherSource.errors?.required
                " required />
            </div>
            <div *ngIf="
                otherSource.invalid &&
                (otherSource.dirty || otherSource.touched)
              " class="col-sm-12">
              <div *ngIf="otherSource.errors.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                Other Source is required.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row ml-md-5">
          <div class="form-group form-check ml-3">
            <label class="form-check-label">
              By providing your phone number, you agree to receive text messages
              from eGlobalDoctors. Message and data rates may apply. Message
              frequency varies.
            </label>
          </div>
        </div>
        <div class="form-group row ml-md-5">
          <div class="form-group form-check ml-5">
            <input type="checkbox" [(ngModel)]="
                this.patientreg.other_data.terms_and_conditions_checkbox
              " class="form-check-input register-checkbox-fix" id="terms" name="terms" />
            <label class="form-check-label" for="customCheck1">
              I agree to the
              <a [href]="this.terms_and_conditions_url" target="_blank">Terms &amp; Conditions</a>
            </label>
          </div>
        </div>

        <div class="form-group row justify-content-center">
          <div class="m-3">
            <div id="recaptcha-div2">
              <re-captcha *ngIf="this.patientreg.other_data.recaptchaData.recaptcha_Reset" class="recaptcha ng-valid"
                name="recaptcha" matInput style="display: inline-block" (resolved)="resolved($event)"
                [(ngModel)]="this.patientreg.api_data.userPatient.recaptcha" #recaptcha="ngModel" [siteKey]="sitekey"
                required>
              </re-captcha>
            </div>
          </div>
        </div>

        <div class="form-group row justify-content-center">
          <div class="col-md-10 col-sm-12">
            <div class="form-submit-button my-3">
              <button type="submit" [disabled]="
                  isPosting() ||
                  !this.patientreg.other_data.terms_and_conditions_checkbox ||
                  !registerForm.valid
                " class="btn btn-primary font-weight-bold text-white p-2">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="this.patientreg.other_data.tabViewData.selected_tab == 1">
    <div class="form-heading-section mt-4">
      <h2>Verify Mobile</h2>
      <p class="form-sub-heading">We have sent an OTP on</p>
      <h2>{{ this.patientreg.api_data.userPatient.primary_contact_number }}</h2>
    </div>
    <div class="form-div">
      <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
        <div class="form-group row">
          <otp-input class="col-12" [isPrimeNg]="false" [otp_data]="this.patientreg.api_data.otp_data"
            (otp_resend)="otp_resend()">
          </otp-input>
        </div>

        <div class="form-group row">
          <div class="col-md-9 col-sm-12">
            <div class="form-submit-button my-3">
              <button type="submit" class="btn btn-primary font-weight-bold text-white p-2"
                [disabled]="isPosting() || !otpForm.valid">
                Verify
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>

  <div class="row">
    <div class="mt-3 mx-2">
      <div class="row">
        <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
        </app-loading>
      </div>

      <app-error-messages [api_result]="this.patientreg.api_data.create_api_result"></app-error-messages>

      <app-error-messages [api_result]="this.patientreg.api_data.otp_data.otp_api_result">
      </app-error-messages>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 mx-4 mx-md-0 mx-lg-0">
      <p>
        Already have an account ?
        <a [routerLink]="['/', this.slug, 'user', 'login', 'patient']"> Sign in</a>
      </p>
    </div>
  </div>

  <div class="footer-copyright-section mt-4">
    <p class="footer-copyright-text text-center">
      2025 Copyright <span>&#169;</span> All rights reserved by
      <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL', '', '_self')"
        style="color: #1850a0">eGlobalDoctors</a>
    </p>
  </div>
</div>